import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavService {

  private drawer$: BehaviorSubject<string> = new BehaviorSubject(null);
  private panel$: BehaviorSubject<string> = new BehaviorSubject('hide');

  constructor() { }

  getDrawerObs(): Observable<string> {
    return this.drawer$.asObservable();
 }

  setDrawerObs(drawer: string): void {
      this.drawer$.next(drawer);
  }

  getPanelObs(): Observable<string> {
    return this.panel$.asObservable();
 }

  setPanelObs(panel: string): void {
      this.panel$.next(panel);
  }
}
